export const counter = () => {
  const counters = document.querySelectorAll('.js-counter');
  if (!counters.length) return;

  const formatInt = (n) =>
    new Intl.NumberFormat('pl-PL', { maximumFractionDigits: 0 }).format(n);

  const animate = (el, target, duration = 2200) => {
    const start = 0;
    const startTime = performance.now();

    const frame = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = Math.round(start + (target - start) * eased);

      el.textContent = formatInt(value);

      if (progress < 1) {
        requestAnimationFrame(frame);
      }
    };

    requestAnimationFrame(frame);
  };

  const started = new WeakSet();

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const el = entry.target;
        if (started.has(el)) return;

        started.add(el);
        const target = Number(el.dataset.target || 0);

        animate(el, target);
        observer.unobserve(el);
      });
    },
    { threshold: 0.35 }
  );

  counters.forEach((el) => observer.observe(el));
};